import React, {useMemo, useRef, useCallback} from "react";
import { Grid } from "@mui/material";
import SortFilter from "../../SortFilter/SortFilter";
import { submittedCorrectionSortByFields } from "./data";
import { getAllLocationsByBuyer } from "../../location/requests/location-requests";
import useGetRequestBody from "../../../hooks/useGetRequestBody";
import {FilterInputProps} from "../../SortFilter/interfaces";
import {useSnackbar} from "../../../context/snackbar-context";

interface QueryProps {
  orderNumber: string,
  locationId: string | undefined,
  equipmentNumber: string,
  supplierName: string,
  sortBy: string,
  sortDir?: string,
}

interface LocationProps {
  id: string,
}

interface SortFilterCallback {
    filters: FilterInputProps[];
    selectFilters?: FilterInputProps[];
    groupBy?: string;
    sortBy: string;
    location: LocationProps | undefined
    sortDir?: string,
  }

interface SortFilterProps {
    query: QueryProps,
    setQuery: (newProps: QueryProps) => void,
    setSort: (sort: any) => void,
}

const ReviewAndCorrectSortFilter = (props: SortFilterProps) => {

  const {query, setQuery, setSort} = props;

  const { snackbarShowMessage } = useSnackbar();
  const buyerLocations = useGetRequestBody(getAllLocationsByBuyer, useMemo(() => [], []), snackbarShowMessage);

  const filterTypes = useMemo(() => {
    return {
      orderNumber: {type: 'orderNumber', label: 'Booking Number'},
      supplierName: {type: 'supplierName', label: 'Supplier Name'},
      equipmentNumber: {type: 'equipmentNumber', label: 'Equipment Number'}
    }
  }, [])

  const locations = useMemo(() => {
    return [{id: "", locationName: "All"}, ...buyerLocations];
  },[buyerLocations]);

  const initialRender = useRef(true);

  const handleCallback = useCallback((input: SortFilterCallback) => {
    const {location, filters, sortBy, sortDir} = input;

    const getFilterValue: (input:{type: string}) => string = ({type}) => filters.find(filter => filter.name === type)?.value || '';

    if (!initialRender.current) {

      setSort((prev: any) => ({...prev, value: sortBy, direction: sortDir}))

      setQuery({
          locationId: location?.id,
          orderNumber: getFilterValue(filterTypes.orderNumber),
          equipmentNumber: getFilterValue(filterTypes.equipmentNumber),
          supplierName: getFilterValue(filterTypes.supplierName),
          sortBy: sortBy,
          sortDir: sortDir,
        })
    } else {
        initialRender.current = false;
    }
  }, [setQuery, setSort, filterTypes]);

  const filterByOptions: FilterInputProps[] = [
    {
      name: filterTypes.orderNumber.type,
      numberField: true,
      label: filterTypes.orderNumber.label,
      value: query.orderNumber,
    },
    {
      name: filterTypes.supplierName.type,
      numberField: false,
      label: filterTypes.supplierName.label,
      value: query.supplierName,
    },
    {
      name: filterTypes.equipmentNumber.type,
      numberField: false,
      label: filterTypes.equipmentNumber.label,
      value: query.equipmentNumber,
    }
  ];

  const key = `submitted-corrections-filter-${locations.length}`;

  return (
    <Grid item container spacing={2} direction={"column"}>
      <SortFilter
        key={key}
        filterCallback={handleCallback}
        sortByOption={submittedCorrectionSortByFields}
        sortDir="desc"
        filterByOption={filterByOptions}
        locations={locations}
        defaultSortBy={submittedCorrectionSortByFields[0].value}
        debounceTime={1000}
      />
    </Grid>
  )
};

export default ReviewAndCorrectSortFilter;
